<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full md:bg-white md:rounded-lg md:shadow-l md:p-8 space-y-6">

    <div class="flex items-center justify-between mb-8">
      <h1 class="text-xl font-bold">Documenti IMS</h1>
    </div>

    <app-search-panel [searchFields]="searchPanelConfig" (searchParamChange)="onSearchParamChange($event)"></app-search-panel>

    <div class="shadow-lg overflow-auto w-full">
      <div class="grid w-full table-grid gap-x-8 gap-y-6 px-6 py-3">
        <div class="table-header-row" (click)="setOrder('id')">ID <span *ngIf="currentSort.field === 'id'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span> </div>
        <div class="table-header-row" (click)="setOrder('filename')">Nome  <span *ngIf="currentSort.field === 'filename'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row" (click)="setOrder('ims_document_type_id')">Tipo  <span *ngIf="currentSort.field === 'ims_document_type_id'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row" (click)="setOrder('registration_date')">Data Registrazione  <span *ngIf="currentSort.field === 'registration_date'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row">Azioni</div>
        @for (d of pagedData; track d.id) {
          <div class="contents hover:bg-gray-100 odd:bg-white even:bg-gray-50 cursor-pointer whitespace-nowrap text-sm text-gray-900" >
            <div>{{ d.document_id }}</div>
            <div>{{ d.filename  }}</div>
            <div>{{ d.type  }}</div>
            <div>{{ d.write_date }}</div>
            <div class="flex gap-x-4">
              <button class="button" (click)="previewDocument(d.document_id, d.mimetype)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 7V5a2 2 0 0 1 2-2h2"/>
                  <path d="M17 3h2a2 2 0 0 1 2 2v2"/>
                  <path d="M21 17v2a2 2 0 0 1-2 2h-2"/>
                  <path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
                  <circle cx="12" cy="12" r="3"/>
                  <path d="m16 16-1.9-1.9"/>
                </svg>
              </button>
              <button class="button" (click)="downloadDocument(d.document_id, d.mimetype)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 17V3"/>
                  <path d="m6 11 6 6 6-6"/>
                  <path d="M19 21H5"/>
                </svg>
              </button>

            </div>
          </div>
        }
      </div>
    </div>

    <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pagination>

    <div class="flex items-center justify-end mb-8">
      <button (click)="fetchDocuments({})" class="button">
        Aggiorna Elenco
      </button>
    </div>

    <div class="document-preview">
      <div class="dimmer" (click)="closePreview()"></div>
      <div class="preview-content">
        <iframe #iframe class="iframe"></iframe>
      </div>
    </div>

  </div>
</div>
